import { CommonRegistry, TransformData } from '@common/components/components';

import { EntityDestroyedPayload } from '../api';
import {
  CommonFilteredComponentSystem,
  FilteredComponentSystemUpdateEntityArgs,
} from './SystemBase';

export class DestroyMarkedEntitiesSystem extends CommonFilteredComponentSystem {
  public componentClasses: (keyof CommonRegistry)[] = ['MarkedForDestruction'];

  updateEntity({ world, entityId }: FilteredComponentSystemUpdateEntityArgs<CommonRegistry>): void {
    const transform = world.getComponent(entityId, 'Transform') as unknown as TransformData;
    const sceneId = transform ? transform.sceneId : undefined;

    this.destroyEntity(entityId);

    // Push custom payload with sceneId for AOI filtering (not auto-generated by World)
    const payload: EntityDestroyedPayload = {
      type: 'entityDestroyed',
      entityId,
      sceneId,
    };
    this.messageQueue.push(payload);
  }
}
